module.exports = __webpack_public_path__ + "img/activity_other2.61903872.jpg";